import { Box, Grid } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

import { BREAKPOINTS } from 'artkive/utils/constants'

export const imageSectionMobileHeightPx = 310

export const Wrapper = styled('div')(({ theme, bgColor, reverse }) => ({
  display: 'flex',
  alignItems: 'center',
  background: theme.colors.white,
  overflow: 'hidden',
  width: '100%',
  height: 'auto',
  [theme.breakpoints.up('md')]: {
    background: reverse
      ? `linear-gradient(90deg, #fff 50%, ${bgColor} 50%)`
      : `linear-gradient(90deg, ${bgColor} 50%, #fff 50%)`,
    height: 800,
  },
}))

export const ContainerWrapper = styled('div')(({ theme }) => ({
  width: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up(BREAKPOINTS.lg)]: {
    maxWidth: '1280px',
  },
  [theme.breakpoints.up(BREAKPOINTS.xl)]: {
    maxWidth: '1480px',
  },
  [theme.breakpoints.up(BREAKPOINTS.xxl)]: {
    maxWidth: '1420px',
  },
}))

export const ImageGridWrapper = styled(Grid)(({ theme, bgColor, reverse }) => ({
  order: reverse ? 2 : 1,
  display: 'flex',
  paddingRight: reverse ? 0 : '120px',
  paddingLeft: reverse ? '120px' : 0,
  position: 'relative',
  [theme.breakpoints.down(BREAKPOINTS.xxl)]: {
    padding: '0 88px',
  },
  [theme.breakpoints.down(BREAKPOINTS.xl)]: {
    padding: '0 80px',
  },
  [theme.breakpoints.down(BREAKPOINTS.lg)]: {
    padding: '0 40px',
  },
  [theme.breakpoints.down(BREAKPOINTS.md)]: {
    padding: 0,
    flexBasis: 0,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: bgColor,
    maxHeight: `${imageSectionMobileHeightPx}px`,
  },
}))

export const Picture = styled('picture')(({ theme }) => ({
  height: '100%',
  '& > img': {
    objectFit: 'contain',
    height: '100%',
    width: '100%',
  },
  [theme.breakpoints.down(BREAKPOINTS.md)]: {
    '& > img': {
      width: 'auto',
      height: '88%',
    },
  },
}))

export const DescriptionGridWrapper = styled(Grid)(({ theme, reverse, maxWidth }) => ({
  order: reverse ? 1 : 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.down(BREAKPOINTS.md)]: {
    maxWidth: maxWidth,
    margin: '0 auto',
  },
}))

export const DescriptionContentBox = styled(Box)(({ theme, reverse }) => ({
  paddingRight: reverse ? '120px' : '16px',
  paddingLeft: reverse ? '16px' : '120px',
  paddingTop: 0,
  paddingBottom: 0,
  [theme.breakpoints.down(BREAKPOINTS.xxl)]: {
    padding: '0 88px',
  },
  [theme.breakpoints.down(BREAKPOINTS.xl)]: {
    padding: '0 80px',
  },
  [theme.breakpoints.down(BREAKPOINTS.lg)]: {
    padding: '0 40px',
  },
  [theme.breakpoints.down(BREAKPOINTS.md)]: {
    paddingLeft: '16px',
    paddingRight: '16px',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(8),
    backgroundColor: theme.colors.white,
  },
}))
